// import { useQuery } from '@tanstack/react-query';
// import sosLogServices from '../services/sos-log.service';

// export const useSosLogs = ({
//   page = 1,
//   limit = 10,
//   status,
//   userType,
//   alertType,
//   userId,
//   startDate,
//   endDate,
//   sortBy = 'createdAt',
//   sortOrder = 'desc',
// } = {}) => {
//   return useQuery({
//     queryKey: ['sos-logs', page, limit, status, userType, alertType, userId, startDate, endDate, sortBy, sortOrder],
//     queryFn: () =>
//       sosLogServices.getSosLogs({
//         page,
//         limit,
//         status,
//         userType,
//         alertType,
//         userId,
//         startDate,
//         endDate,
//         sortBy,
//         sortOrder,
//       }),
//     staleTime: 30 * 1000, // 30 seconds
//     gcTime: 5 * 60 * 1000, // 5 minutes
//     refetchOnWindowFocus: true,
//   });
// };


import { useQuery } from '@tanstack/react-query';
import sosLogServices from '../services/sos-log.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get all SOS logs
 */
export const useSosLogs = ({
  page = 1,
  limit = 10,
  status,
  userType,
  alertType,
  userId,
  startDate,
  endDate,
  sortBy = 'createdAt',
  sortOrder = 'desc',
} = {}) => {
  return useQuery({
    queryKey: [
      'sos-logs',
      {
        page,
        limit,
        status,
        userType,
        alertType,
        userId,
        startDate,
        endDate,
        sortBy,
        sortOrder,
      },
    ],

    queryFn: async () => {
      try {
        return await sosLogServices.getSosLogs({
          page,
          limit,
          status,
          userType,
          alertType,
          userId,
          startDate,
          endDate,
          sortBy,
          sortOrder,
        });
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 30 * 1000, // 30 seconds
    gcTime: 5 * 60 * 1000, // 5 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,

    refetchOnWindowFocus: true,
  });
};